import React from 'react';
import './card.styles.css';

export const Card = ({post,onDelete,onLike}) =>{

    let classes="mr-2 btn btn-";
    classes += (post.liked === true) ? "danger" : "outline-primary";

    return(
        /*<div className="card">

            <img src={`https://picsum.photos/id/${post.id}/200/300?random=1`} alt="The Sanctuary of Tomorrow"/>

            <div className="card-body text-center pb-0">
                <h5>{post.title}</h5>

                <p className="mb-0 pb-0">
                    {post.body}

                </p>
            </div>
            <small className="text-muted text-dark custom-classes">{post.id}</small>
            <div className="card-footer">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="btn">
                        <button
                            className={classes}
                            onClick={()=>onLike(post)}
                        >
                            <i className="fas fa-heart"/>
                        </button>


                        <button className="btn btn-outline-secondary">
                            <i className="far fa-sticky-note"/>
                        </button>

                    </div>

                    <button
                        className="btn btn-outline-danger"
                        onClick={()=>onDelete(post.id)}
                    >
                        <i className="fas fa-trash-alt"/>
                    </button>
                </div>
            </div>
        </div>*/
        <div className="col-md-6 col-sm-12 col-lg-4 mb-2">
            <div className="custom-container">
                <div className="card">

                <img src={`https://picsum.photos/id/${post.id}/200/250?random=1`} alt="The Sanctuary of Tomorrow"/>

                <div className="card-body text-center pb-0">
                    <h5>{post.title.substr(0,20)+'...'}</h5>

                    <p className="mb-0 pb-0">
                        {post.body.substr(0,120)+'...'}
                        <span className="text-primary">read more</span>
                    </p>
                </div>
                {/*<small className="text-muted text-dark custom-classes">{post.id}</small>*/}
                <div className="card-footer">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="btn">
                            <button
                                className={classes}
                                onClick={()=>onLike(post)}
                            >
                                <i className="fas fa-heart"/>
                            </button>


                            <button className="btn btn-outline-secondary">
                                <i className="far fa-sticky-note"/>
                            </button>

                        </div>

                        <button
                            className="btn btn-outline-danger"
                            onClick={()=>onDelete(post.id)}
                        >
                            <i className="fas fa-trash-alt"/>
                        </button>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
};